import { makeStyles } from '@material-ui/core/styles';
import { ERebrandingFonts } from 'helpers/constants';

export const STEP_ITEM_HEIGHT = 32;

export const useStyles = makeStyles((theme) => ({
  root: {
    position: 'absolute',
    left: '-50%',
    height: '100%',
    '& nav': {
      position: 'fixed',
      transform: 'translateX(-50%)',
      '& > span': {
        position: 'absolute',
        left: 0,
        backgroundColor: '#072D83',
        width: 2,
        height: STEP_ITEM_HEIGHT,
        transitionDuration: '500ms',
        transitionProperty: 'top, opacity',
        '&.--finished': {
          opacity: 0,
        },
      },
      '& ol': {
        listStyle: 'none',
        display: 'flex',
        flexDirection: 'column',
        borderLeft: '1px solid #B0BEC5',
      },
    },
    ['@media screen and (max-width: 1500px)']: {
      left: '-30%',
    },
    ['@media screen and (max-width: 1100px)']: {
      display: 'none',
    },
  },
  item: {
    '& button': {
      display: 'flex',
      alignItems: 'center',
      height: STEP_ITEM_HEIGHT,
      fontSize: 14,
      lineHeight: `${STEP_ITEM_HEIGHT}px`,
      fontWeight: 600,
      // transition: 'all 500ms',
      backgroundColor: 'transparent',
      paddingLeft: theme.spacing(2),
      border: 0,
      fontFamily: ERebrandingFonts.OPENSANS,
      '&:disabled': {
        cursor: 'not-allowed',
      },
    },
    '&.--next': {
      '& button': {
        color: '#B0BEC5',
        cursor: 'not-allowed',
      },
    },
    '&.--current': {
      '& button': {
        color: '#072D83',
        fontWeight: 700,
      },
    },
    '&.--done': {
      '& button': {
        color: '#546E7A',
        cursor: 'pointer',
      },
    },
  },
  doneIcon: {
    fontSize: 16,
    color: '#4CAF50',
    marginRight: 5,
    transitionDuration: '500ms',
    transitionProperty: 'transform, width',
    transform: 'scale(0)',
    width: 0,
    '&.--shown': {
      transform: 'scale(1)',
      width: 16,
    },
  },
}));
